module.exports = __webpack_public_path__ + "static/media/1.821b91a4.png";